/**
 * @generated SignedSource<<faa3b9deabd3b02774a7d35a034a53a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandDashboard_brand$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"InternAgreementsCard_brand" | "InternBrandActivityChart_brand" | "InternBrandStatCards_brand" | "InternIntegrationsCard_brand" | "InternNotificationsCard_brand">;
  readonly " $fragmentType": "InternBrandDashboard_brand";
};
export type InternBrandDashboard_brand$key = {
  readonly " $data"?: InternBrandDashboard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandDashboard_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandDashboard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InternAgreementsCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InternNotificationsCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InternBrandStatCards_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InternBrandActivityChart_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InternIntegrationsCard_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "9eed0b74d4338f87d98abd81f4343fa1";

export default node;
